import React, { useEffect, useState } from "react";
import { Table, Button, Container, Spinner, Alert } from "react-bootstrap";

const WithdrawApprovement = () => {
  const [withdraws, setWithdraws] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Ambil data withdraw yang is_approved = false
  const fetchWithdraws = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://api.backofficemain.com/get_pending_withdraw.php");
      const data = await response.json();

      if (data.success) {
        setWithdraws(data.data);
      } else {
        setError(data.error || "Failed to fetch data");
      }
    } catch (err) {
      setError("Error fetching data: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdraws();
  }, []);

  // Fungsi Approve
  const handleApprove = async (id) => {
    if (!window.confirm("Are you sure to approve this withdraw?")) return;

    try {
      const response = await fetch("https://api.backofficemain.com/approve_withdraw.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Withdraw approved successfully");
        fetchWithdraws();
      } else {
        alert("Error approving withdraw: " + data.error);
      }
    } catch (err) {
      alert("Server error: " + err.message);
    }
  };

  // Fungsi Decline
  const handleDecline = async (id) => {
    if (!window.confirm("Are you sure to decline this withdraw?")) return;

    try {
      const response = await fetch("https://api.backofficemain.com/decline_withdraw.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Withdraw declined and removed");
        fetchWithdraws();
      } else {
        alert("Error declining withdraw: " + data.error);
      }
    } catch (err) {
      alert("Server error: " + err.message);
    }
  };

  return (
    <Container className="mt-4">
      <h4 className="mb-3">Withdraw Approvement</h4>

      {loading ? (
        <div className="text-center mt-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <Table bordered hover responsive className="shadow-sm">
          <thead className="table-light">
            <tr>
              <th>No</th>
              <th>User</th>
              <th>Staff</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {withdraws.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No pending withdraws found.
                </td>
              </tr>
            ) : (
              withdraws.map((w, index) => (
                <tr key={w.id}>
                  <td>{index + 1}</td>
                  <td>{w.user_username}</td>
                  <td>{w.staff_username}</td>
                  <td>${parseFloat(w.amount).toLocaleString()}</td>
                  <td>{new Date(w.created_at).toLocaleString()}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      className="me-2"
                      onClick={() => handleApprove(w.id)}
                    >
                      Accept
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDecline(w.id)}
                    >
                      Decline
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default WithdrawApprovement;
